{
  "removeButtonLabel": "Rimuovi",
  "removeDescription": "Premi Elimina per rimuovere il tag."
}
